export function countTypeToTitle(ct: string): string {
  switch (ct) {
    case "views":
      return "Sessions";
    case "viewers":
      return "Unique Viewers";
    case "playout_secs":
      return "Hours Streamed";
    case "peak_viewers":
      return "Peak Viewership";
    default:
      console.error(`Unknown count type ${ct}`);
      return "Sessions";
  }
}

export function titleToCountType(title: string): string {
  switch (title) {
    case "Sessions":
      return "views";
    case "Unique Viewers":
      return "viewers";
    case "Hours Streamed":
      return "playout_secs";
    case "Peak Viewership":
      return "peak_viewers";
    default:
      console.error(`Unknown title ${title}`);
      return "views";
  }
}
